import { Options, Vue } from "vue-class-component";

@Options({})
export default class Error403 extends Vue {}
